
import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GlobalLoader } from '../components/GlobalLoader';

export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { user, isLoading } = useAuth();
  
  // 1. Vänta tills vi vet status (AuthContext hanterar session-checken)
  if (isLoading) {
      return <GlobalLoader message="Kontrollerar behörighet..." />;
  }
  
  // 2. Om ingen användare är laddad (eller session saknas), skicka till start
  if (!user) {
      return <Navigate to="/" replace />;
  }

  // 3. Om användaren är inloggad men status är 'PENDING' eller 'DEACTIVATED'
  // (Detta hanteras oftast redan i AuthContext men som extra säkerhet)
  if (user.status === 'PENDING' || user.status === 'DEACTIVATED') {
      return <Navigate to="/" replace />;
  }

  // 4. Allt grönt - rendera appen
  return <>{children}</>;
};
